import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { LandingPage } from 'src/app/pages/landing/landing.page';
import { AuthService } from 'src/app/services/auth.service';
import { PushNotificationsService } from 'src/app/services/pushnotifications.service';

@Component({
  selector: 'app-notifications-banner',
  templateUrl: './notifications-banner.component.html',
  styleUrls: ['./notifications-banner.component.scss'],
})
export class NotificationsBannerComponent  implements OnInit {
  @Input() presentingElement:HTMLIonRouterOutletElement;

  constructor(
    private modalCtrl:ModalController,
    public notifications:PushNotificationsService
  ) { 
  
  }

  async ngOnInit() {
 
  }

  async askNotificationPermissions() {
    await this.notifications.askForPermissions();
  }

  

  


}
